import { FocusEvent as ReactFocusEvent, PointerEvent as ReactPointerEvent, useRef, useState } from 'react';

import isFocusVisible from './isFocusVisible';

const usePointerType = (isTouchMedia: boolean) => {
  const [pointerType, setPointerType] = useState<string | null>(null);
  const pointerTypeRef = useRef<string | null>(null);

  const isTouch = pointerType === null ? isTouchMedia : pointerType === 'touch';

  const isTouchNow = () => (pointerTypeRef.current === null ? isTouchMedia : pointerTypeRef.current === 'touch');

  const handlePointerType = (event: ReactPointerEvent) => {
    if (event.pointerType && event.pointerType !== pointerTypeRef.current) {
      pointerTypeRef.current = event.pointerType;
      setPointerType(event.pointerType);
    }
  };

  const handleFocus = (event: ReactFocusEvent<HTMLElement>) => {
    if (isFocusVisible(event.currentTarget)) {
      pointerTypeRef.current = 'keyboard';
      setPointerType('keyboard');
    }
  };

  return { isTouch, isTouchNow, handlePointerType, handleFocus };
};

export default usePointerType;
